module.exports = __webpack_public_path__ + "img/pay-item-3.2769b632.png";